import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import McpDemoThumbnail from "../../../../assets/McpServer/videos/mcp-demo-thumbnail.png";
import McpDemoVideo from "../../../../assets/McpServer/videos/mcp-demo-video.mp4";
import BriaVideo from "../../../common/BriaVideo/BriaVideo.tsx";
import McpServerInstallSection from "../McpServerInstallSection/McpServerInstallSection.tsx";
import styles from "./McpServerHeaderSection.module.scss";

const McpServerHeaderSection: React.FC = () => {
	const { t } = useTranslation("translation", { keyPrefix: "mcpServer.headerSection" });
	const isBigScreen = useMediaQuery("(min-width:2460px)");

	return (
		<Box className={styles.headerContainer}>
			<Box className={styles.headerSection}>
				<Box className={styles.textContainer}>
					<Typography className={styles.title}>{t("title")}</Typography>

					<Typography className={styles.description}>{t("description1")}</Typography>

					<Typography className={styles.benefitsTitle}>{t("keyBenefits")}</Typography>

					<Typography className={styles.description}>
						<span className={styles.descriptionBold}>{t("benefit1.title")}</span>
						{t("benefit1.description")}
					</Typography>

					<Typography className={styles.description}>
						<span className={styles.descriptionBold}>{t("benefit2.title")}</span>
						{t("benefit2.description")}
					</Typography>

					<Typography className={styles.description}>
						<span className={styles.descriptionBold}>{t("benefit3.title")}</span>
						{t("benefit3.description")}
					</Typography>
					{isBigScreen && (
						<Box className={styles.installSectionWrapper}>
						<Divider className={styles.divider} />
							<McpServerInstallSection />
						</Box>
					)}
				</Box>

				<Box className={styles.videoContainer}>
					<BriaVideo thumbnail={McpDemoThumbnail} videoSrc={McpDemoVideo} />
				</Box>
			</Box>
		</Box>
	);
};

export default McpServerHeaderSection;
